import React from 'react';
import { Card, Statistic, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { useTheme } from '../../theme/ThemeProvider';

const VARIANTS = {
  blue: { bg: '#e6f4ff', color: '#1677ff' },
  purple: { bg: '#f9f0ff', color: '#722ed1' },
  cyan: { bg: '#e6fffb', color: '#13c2c2' },
  green: { bg: '#f6ffed', color: '#52c41a' },
  red: { bg: '#fff1f0', color: '#cf1322' },
  orange: { bg: '#fff7e6', color: '#fa8c16' },
};

const VARIANTS_DARK = {
  blue: { bg: 'rgba(22, 119, 255, 0.15)', color: '#69b1ff' },
  purple: { bg: 'rgba(114, 46, 209, 0.15)', color: '#b37feb' },
  cyan: { bg: 'rgba(19, 194, 194, 0.15)', color: '#5cdbd3' },
  green: { bg: 'rgba(82, 196, 26, 0.12)', color: '#95de64' },
  red: { bg: 'rgba(255, 77, 79, 0.12)', color: '#ff7875' },
  orange: { bg: 'rgba(250, 140, 22, 0.12)', color: '#ffc069' },
};

const AdminKpiCard = ({ title, value, suffix, icon: Icon, variant = 'blue', hint }) => {
  const { darkMode } = useTheme();
  const palette = darkMode ? VARIANTS_DARK : VARIANTS;
  const v = palette[variant] || palette.blue;

  const titleNode = hint ? (
    <Tooltip title={hint}>
      <span className="admin-kpi-card__title-with-hint">{title}</span>
    </Tooltip>
  ) : (
    title
  );

  return (
    <Card size="small" className="admin-kpi-card" bordered={false}>
      <div className="admin-kpi-card__inner">
        <div className="admin-kpi-card__icon" style={{ background: v.bg, color: v.color }}>
          {Icon && <Icon size={20} strokeWidth={2} />}
        </div>
        <Statistic title={titleNode} value={value} suffix={suffix} />
      </div>
    </Card>
  );
};

AdminKpiCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  suffix: PropTypes.node,
  icon: PropTypes.elementType,
  variant: PropTypes.oneOf(Object.keys(VARIANTS)),
  hint: PropTypes.string,
};

export default AdminKpiCard;
